import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '../utils/mui-imports';
import { WhatsAppIcon, PinterestIcon, ContentCopyIcon } from '../utils/mui-imports';
import { FaShare } from 'react-icons/fa';

const ShareLookButtons = ({ lookId, image, avatarId = null, isAvatar = false }) => {

  // Construct the landing page URL using the provided lookId.
  /*
  var landingUrl;
  if(isAvatar){
        landingUrl = `${window.location.origin}/showcase-avatar/${avatarId}`;
  } else {
    landingUrl = `${window.location.origin}/showcase/${lookId}`;
  }
    */

  const landingUrl = isAvatar ? `${window.location.origin}/showcase-avatar/${avatarId}`: `${window.location.origin}/showcase/${lookId}`;

  console.log(landingUrl);

  // State for copy tooltip and dialog visibility.
  const [copyTooltipOpen, setCopyTooltipOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  // Handlers to open/close the dialog.
  const handleClickOpen = () => setDialogOpen(true);
  const handleClose = () => setDialogOpen(false);

  // Function to handle sharing based on the chosen platform.
  const handleShare = (platform) => {
    if (platform === 'whatsapp') {
      const wa_msg = `👀 Check out the look I just created on Styldrop!\n` + 
      `It’s a mix of my mood + AI magic!` +
      `💬 Save it if you like it — every save helps me earn more credits to create even more styles! 🙌` + 
      `Wanna try creating your own style? It's free →\n` + landingUrl;      
      window.open(`https://wa.me/?text=${encodeURIComponent(wa_msg)}`, '_blank');
    } else if (platform === 'pinterest') {

      window.open(
        `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(
          landingUrl
        )}&media=${encodeURIComponent(image || '')}`,
        '_blank'
      );
    } else if (platform === 'copy') {
      navigator.clipboard.writeText(landingUrl);
      setCopyTooltipOpen(true);
      // Hide the tooltip after 2 seconds
      setTimeout(() => setCopyTooltipOpen(false), 2000);
    }
  };

  return (
    <>
      {/* Share button with icon + text */}
      <Button
        onClick={handleClickOpen}
        sx={{
          display: 'flex',
          alignItems: 'center',
          color: 'black',
          '&:hover': { transform: 'scale(1.1)' },
          transition: 'transform 0.2s ease-in-out',
          padding: 0,
          minWidth: 'auto',
        }}
      >
        <Box px={1}>
          <FaShare />
        </Box>
        <Typography fontWeight="bold" fontSize="0.8rem">
          Share
        </Typography>
      </Button>

      {/* Dialog for share options */}
      <Dialog
      fullWidth
       open={dialogOpen} onClose={handleClose}
       slotProps={{
        paper: {
          sx: {
            backdropFilter: 'blur(8px)',
            backgroundColor: 'rgba(255, 255, 255, 0.6)',
            borderRadius: 5,
          },
        },
        backdrop: {
          backdropFilter: 'blur(8px)',
          backgroundColor: 'rgba(255, 255, 255, 0.3)',
        },
      }}
      // sx={{ zIndex: 2000 }}
       >
        {/* <DialogTitle>Share</DialogTitle> */}
        <DialogContent>
          <Box display="flex" p={1} justifyContent="center" alignItems="center" gap={1}>
            <Button
              onClick={() => handleShare('whatsapp')}
              sx={{ color: 'black', '&:hover': { transform: 'scale(1.1)' }, transition: 'transform 0.2s ease-in-out' }}
            >
              <WhatsAppIcon fontSize='large' />
            </Button>
            <Button
              onClick={() => handleShare('pinterest')}
              sx={{ color: 'black', '&:hover': { transform: 'scale(1.1)' }, transition: 'transform 0.2s ease-in-out' }}
            >
              <PinterestIcon fontSize="large" />
            </Button>
            <Tooltip
              arrow
              title="Copied!"
              open={copyTooltipOpen}
              placement="top"
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <Button
                onClick={() => handleShare('copy')}
                sx={{ color: 'black', '&:hover': { transform: 'scale(1.1)' }, transition: 'transform 0.2s ease-in-out' }}
              >
                <ContentCopyIcon fontSize="large" />
              </Button>
            </Tooltip>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ShareLookButtons;
